<template>
<div class="d-flex justify-content-center">
    <nav aria-label="Page navigation">
        <ul class="pagination">
            <!-- Previous -->
            <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage - 1)">
                    ‹
                </a>
            </li>

            <!-- First Page -->
            <li v-if="showFirstPage" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
            </li>
            <li v-if="showFirstEllipsis" class="page-item disabled">
                <span class="page-link">...</span>
            </li>

            <!-- Page Numbers -->
            <li v-for="page in displayedPages" 
                :key="page" 
                class="page-item"
                :class="{ active: page === pagination.currentPage }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">
                    {{ page }}
                </a>
            </li>

            <!-- Last Page -->
            <li v-if="showLastEllipsis" class="page-item disabled">
                <span class="page-link">...</span>
            </li>
            <li v-if="showLastPage" class="page-item">
                <a class="page-link" href="#" 
                   @click.prevent="changePage(pagination.totalPages)">
                    {{ pagination.totalPages }}
                </a>
            </li>

            <!-- Next -->
            <li class="page-item" 
                :class="{ disabled: pagination.currentPage === pagination.totalPages }">
                <a class="page-link" href="#" 
                   @click.prevent="changePage(pagination.currentPage + 1)">
                    ›
                </a>
            </li>
        </ul>
    </nav>
</div>
</template>

<script>

export default {
    props: {
        pagination: {
            type: Object,
            required: true
        }
    },
    computed: {
        displayedPages() {
            let pages = [];
            const current = this.pagination.currentPage;
            const total = this.pagination.totalPages;

            // Mostra sempre 5 pagine intorno alla pagina corrente
            for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) {
                pages.push(i);
            }
            return pages;
        },
        showFirstPage() {
            return !this.displayedPages.includes(1);
        },
        showLastPage() {
            return !this.displayedPages.includes(this.pagination.totalPages);
        },
        showFirstEllipsis() {
            return this.displayedPages[0] > 2;
        },
        showLastEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pagination.totalPages - 1;
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page);
        }
    },
}
</script>